/*document.addEventListener('DOMContentLoaded', function (event) {
    document.querySelectorAll("[data-active-filter]").forEach(function (element){
        element.click();
    })
});*/
